import { Field, Int, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class BookTagDto {
  @Field()
  name!: string

  @Field(t => Int)
  count!: number
}
